/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */

import { ofType } from 'redux-observable';
import { map, ignoreElements } from 'rxjs/operators';
import isEqual from 'lodash.isequal';
import { Observable } from 'rxjs';

import * as actionType from '../actions';
import { ActionManagerInstance } from '../../../actions/manager';
import { getInitialState } from '../reducers';
import { getStore } from '../state-manager';
import type { Action } from '../state-manager';

// misc-epic is for Redux-Observable Epic's that don't really fit into
//  any of the other existing categories.

const resetStore = (action$: Observable<Action>) => {
  // Need to define these in this scope so they can be set/used
  //  in various parts of the processing.
  let actionMgrID = 0;

  return action$.pipe(
    ofType(actionType.RESET_STORE),
    map((action: Action) => {
      // extract the Action Manager ID from the payload

      ({ actionMgrID } = action.payload);
      // need to return the Redux-Observable object to keep the chaining working...
      return action.payload;
    }),
    // this is the right place to note that the promise should resolve...

    map(() => {
      const theCurrentStore = getStore()?.getState();
      const theInitialStore = getInitialState();

      // Make sure the store has been reset
      //  and there was an actionMgrID provided (a real actionMgrID will be > 0 and not undefined)
      if (isEqual(theCurrentStore, theInitialStore) && actionMgrID > 0) {
        ActionManagerInstance.resolveActionByID(actionMgrID, {});
      } else {
        ActionManagerInstance.rejectActionByID(actionMgrID);
      }

      return [];
    }),
    ignoreElements()
  );
};

const miscEpics = [resetStore];

export default miscEpics;
